module.exports = __webpack_public_path__ + "img/600.ae6c8269.jpg";